import { FormGroup, FormHelpText, FormTextarea } from '@spotify-internal/encore-web';

import withTranslation from 'lib/shared/i18n/withTranslation';

import BaseField from '../BaseField/BaseField';

import styles from './TextareaField.module.scss';

export const getAriaLive = (inputLength, maxLength) => {
  if (inputLength > maxLength - 4 && inputLength < maxLength) return 'assertive';
  else if (inputLength !== 0 && inputLength % 50 === 0) return 'polite';
  return 'off';
};

class TextareaField extends BaseField {
  getError(fieldError) {
    if (!this.showError()) return null;

    return (
      <FormHelpText id={fieldError} data-testid="validation-error" error>
        {this.getErrorMessage()}
      </FormHelpText>
    );
  }

  render() {
    const { field, t, value, tPrefix } = this.props;
    const helpText = field.help_text && t(`${tPrefix}${field.name}_help_text`);
    const charCountId = `charCount_${field.name}`;
    const ariaDescribedBy = field.maxlength ? charCountId : field.name;
    const fieldError = `${ariaDescribedBy}-error`;

    return (
      <FormGroup
        data-error={this.showError()}
        key={field.name}
        label={this.getLabel()}
        labelFor={field.name}
        indicator={this.getIndicator()}
      >
        <FormTextarea
          className={styles.textarea}
          id={field.name}
          aria-describedby={this.showError() ? fieldError : ariaDescribedBy}
          aria-required={field.required}
          aria-invalid={this.showError()}
          placeholder={this.getPlaceholder()}
          onChange={this.fieldChange}
          value={value}
          error={this.showError()}
          maxLength={field.maxlength}
        />
        {(helpText || field.maxlength) && (
          <div className={styles.caption}>
            {helpText && <FormHelpText>{helpText}</FormHelpText>}
            {field.maxlength && (
              <FormHelpText
                className={styles.charCounter}
                id={charCountId}
                aria-live={getAriaLive(value.length, field.maxlength)}
              >
                {field.maxlength - value.length}
              </FormHelpText>
            )}
          </div>
        )}
        {this.getError(fieldError)}
      </FormGroup>
    );
  }
}

export default withTranslation()(TextareaField);
